<div class="mb-5">
	<app-daily-utilization-chart
		[chart]="chart"
		[devicesType]="devicesType"
		[hasTruckTypeFilter]="true"
		[title]="'utilization.daily_fleet_utilization_title' | translate"
		[tooltipText]="'daily_fleet_utilization' | translate"
		[vAxisTitle]="'site.number_of_trucks' | translate"
		[userParentFilters]="true"
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedTruckType]="selectedTruckType"
		[selectedTruckManufacturer]="selectedTruckManufacturer"
		(prepareParentFiltersOptions)="onPrepareParentFiltersOptions($event)"
	></app-daily-utilization-chart>
</div>
